export var EntityStatusEnum;
(function (EntityStatusEnum) {
    // прикреплен к холсту
    EntityStatusEnum["ATTACHED"] = "ATTACHED";
    // первое нажатие, видно границы сущности
    EntityStatusEnum["HELD"] = "HELD";
})(EntityStatusEnum || (EntityStatusEnum = {}));
